export default __webpack_public_path__ + "static/list-d4cd93ed3660340e49d839a67feea84b.png";